import SectionMessage from '@atlaskit/section-message';
import Snippet from '@atlaskit/gatsby-theme-brisk/src/components/snippet';
import * as React from 'react';
export default {
  SectionMessage,
  Snippet,
  React
};